export default __webpack_public_path__ + "static/media/8.9ae62823.png";